"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowDownRight } from "lucide-react";
export default function CallToActionRegistration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return;
}